const ROOT = 'CipGeneration/generateForm/processCip';

export const FETCH_PROCESSCIP_REQUEST = `${ROOT}/FETCH_PROCESSCIP_REQUEST`;
export const FETCH_PROCESSCIP_SUCCESS = `${ROOT}/FETCH_PROCESSCIP_SUCCESS`;
export const FETCH_PROCESSCIP_FAILURE = `${ROOT}/FETCH_PROCESSCIP_FAILURE`;
export const FETCH_REFRESHTOKEN_REQUEST = `${ROOT}/FETCH_REFRESHTOKEN_REQUEST`;
export const SET_PAYMENT_TYPE = `${ROOT}/SET_PAYMENT_TYPE`;
export const RESET_PAYMENT_TYPE = `${ROOT}/RESET_PAYMENT_TYPE`;
